import React from "react";
import dayjs from "dayjs";
import DateLogic from "../../utils/DateLogic";
import { getTranslations } from "../../utils/CardTranslations";

const MainPageCard = ({ data, isOpened }) => {
    const t = getTranslations(data.language);

    return (

        <div
            style={{
                height: "100vh", // full page height
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // center content vertically
                alignItems: "center", // center horizontally
                color: "black",
                textAlign: "center",
                backgroundImage: `url(${data.cardBackground})`,
                backgroundSize: "cover", // fills entire area
                backgroundSize: "100% 100%",
                backgroundPosition: "center", // centers image
                backgroundRepeat: "no-repeat", // avoids tiling
                scrollSnapAlign: "start", // used for smooth snap scroll
            }}
        >
            <p
                className={`fade-in ${isOpened ? 'visible' : ''}`}
                style={{
                    fontSize: data.fontSizeMajlis || "14px",
                    color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour,
                    fontFamily: "Playfair",
                    lineHeight: data.textLayoutMajlis === "break" ? "1" : "normal",
                    transitionDelay: '0.8s',
                }}
            >
                {data.textLayoutMajlis === "break"
                    ? data.eventType.split(" ").map((word, index) =>
                        index === 0 ? (
                            word
                        ) : (
                            <React.Fragment key={index}>
                                <br />
                                {word}
                            </React.Fragment>
                        )
                    )
                    : data.eventType}
            </p>

            <p
                className={`fade-in ${isOpened ? 'visible' : ''}`}
                style={{
                    fontSize: data.fontSizePengantin || "24px",
                    fontFamily: data.fontBrideStyle,
                    fontWeight: "bold",
                    color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour,
                    margin: "20px 0",
                    whiteSpace: "pre-line",
                    transitionDelay: '1.4s',
                }}
            >
                {data.coupleCount === 'dua'
                    ? data.greetingName?.split(/ & /).map((name, i, arr) => (
                        <span key={i}>
                            {name}
                            {i !== arr.length - 1 && <span style={{ fontSize: "0.65em", margin: "0 15px" }}>&amp;</span>}
                        </span>
                    ))
                    : (data.greetingName || "Adam & Hawa")?.replace(/ & /g, "\n&\n")}
            </p>

            {/* Couple 2 — shown only when coupleCount === 'dua' */}
            {data.coupleCount === 'dua' && data.greetingName2 && (
                <>
                    <p
                        className={`fade-in ${isOpened ? 'visible' : ''}`}
                        style={{
                            transitionDelay: '1.4s',
                        }}
                    >
                        <span style={{
                            fontSize: '13px',
                            color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour,
                            letterSpacing: '1px',
                        }}>
                            {t.together}
                        </span>
                    </p>
                    <p
                        className={`fade-in ${isOpened ? 'visible' : ''}`}
                        style={{
                            fontSize: data.fontSizePengantin || "24px",
                            fontFamily: data.fontBrideStyle,
                            fontWeight: "bold",
                            color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour,
                            margin: "20px 0",
                            whiteSpace: "pre-line",
                            transitionDelay: '1.4s',
                        }}
                    >
                        {data.greetingName2?.split(/ & /).map((name, i, arr) => (
                            <span key={i}>
                                {name}
                                {i !== arr.length - 1 && <span style={{ fontSize: "0.65em", margin: "0 15px" }}>&amp;</span>}
                            </span>
                        ))}
                    </p>
                </>
            )}

            <div className={`fade-in ${isOpened ? 'visible' : ''}`} style={{ transitionDelay: '2s' }}>
                <p style={{ fontFamily: "Playfair", fontSize: '16px', color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour, }}>
                    {DateLogic.toDay(dayjs(data.eventDate).format("dddd"), data.language)}
                </p>
                <p style={{ fontFamily: "Playfair", fontSize: '16px', color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour, }}>
                    {DateLogic.formatDate(data.eventDate, "D MMM YYYY", data.language)}
                </p>
            </div>

            <p
                className={`fade-in ${isOpened ? 'visible' : ''}`}
                style={{
                    fontFamily: "Playfair",
                    fontSize: '16px',
                    marginTop: "15px",
                    color: data.designCode === "floral-035" ? "#ffe6b5ff" : data.themeColour,
                    transitionDelay: '2.6s'
                }}
            >
                {data.place}
            </p>
        </div>
    )
};

export default MainPageCard;
